import { connect } from 'react-redux';
import Category2B2BDetail from '../../components/Products/Category2B2BDetail';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

function mapStateToProps(state) {
  return {
    category2Products: state.products.category2ProductsB2B,
    category2ProductsIsLoading: state.products.category2ProductsIsLoadingB2B,
    category2Id: state.products.category2IdB2B,

    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,
  };
}

export default connect(mapStateToProps, { checkPassword, clearCheckPassword })(Category2B2BDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/Category2B2BDetail.jsx